import api from '@/apis/eTask/userAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('employee', api);

const state = {
  ...crud.state,

  QLCBEmployeeLoading: false,
  QLCBEmployeeLoadingSummary: false
};
const getters = {
  ...crud.getters
};
const actions = {
  ...crud.actions,

  /**
     * Lấy dữ liệu phòng ban của đơn vị từ QLCB
     * @param {*} context
     * @param {*} payload
     * VDGiang 22/5/2023
     */
  async getDepartmentFromQLCB(context, payload) {
    let res = null;

    try {
      res = await api.getDepartmentFromQLCB(payload);
    }
    catch (e) {
      console.log(e);
    }
    return res;
  },

  /**
 * Lấy dữ liệu hồ sơ cá nhân từ QLCB
 * @param {*} context
 * @param {*} payload
 * VDGiang 22/5/2023
 */
  async getEmployeeFromQLCB(context, payload) {
    let res = null;

    try {
      context.commit("updateLoading", true);
      res = await api.getEmployeeFromQLCB(payload);
    }
    catch (e) {
      console.log(e);
    }
    finally {
      context.commit("updateLoading", false);
    }

    return res;
  },
};
const mutations = {
  ...crud.mutations,

  updateQLCBEmployeeLoading(state, data) {
    state.QLCBEmployeeLoading = data;
  },

  updateQLCBEmployeeLoadingSummary(state, data) {
    state.QLCBEmployeeLoadingSummary = data;
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
